import { Badge } from '@apollo/orbit';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

import { graphRouteConfig, proposalEditorRouteConfig } from '../routes';
const ConflictBadge = ({ className }: { className?: string }) => (
  <Badge variant="warn" className={className}>
    CONFLICT
  </Badge>
);

export const ConflictBadgeWithLink = ({
  className,
  graphVariantName,
  isDisabled,
}: {
  className?: string;
  isDisabled: boolean;
  graphVariantName: string;
}) => {
  const location = useLocation();
  return (
    <Tooltip
      label={`Conflicts exist between this proposal and its source variant. ${!isDisabled ? 'Click to resolve these, otherwise this proposal is not implementable.' : ''}`}
    >
      {isDisabled ? (
        <ConflictBadge className={className} />
      ) : (
        <Link
          to={proposalEditorRouteConfig.locationFrom({
            location,
            fromRouteConfig: graphRouteConfig,
            patch: {
              graphVariant: graphVariantName,
              pullUpstreamChanges: 'true',
            },
          })}
        >
          <ConflictBadge className={className} />
        </Link>
      )}
    </Tooltip>
  );
};
